import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import {OrderStatusPageContext} from "@MasterBluePrint/Overrides/Pages/OrderStatusPage";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FC, useContext } from "react";
import { css } from "styled-components";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { connect } from "react-redux";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";

export interface OrderDetailsNotesStyles {
    titleText?: TypographyProps;
    notesText?: TypographyProps;
    wrapper?: InjectableCss;
}
const mapStateToProps = (state: ApplicationState) => ({
    orderData: state.pages.orderStatus.order,
});
type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export const notesStyles: OrderDetailsNotesStyles = {
    wrapper: {
        css:css`        
            letter-spacing: 0.0313rem;
            line-height: 1.5rem;
            display: flex;
            flex-direction: row;
        `,
    },
    titleText: {
        variant: "h6",
        as: "h3",
        css: css`
            @media print {
                font-size: 0.75rem;
            }
            margin-bottom: 0.3125rem;
            margin-right: 0.625rem;
            color: #002554;
            font-family: 'Roboto', sans-serif;
            font-size: 1rem;
            font-weight: bold;
            display: inline-block;
            white-space: nowrap;
            &:after {
                content: ":";
            }
        `,
    },
    notesText: {
        css:css`
            color: #333F48;
            font-family: 'Lato',sans-serif;
            font-size: 1rem;
        `,
    },
};

const styles = notesStyles;

const OrderDetailsNotes: FC<Props> = ({ orderData }) => {
    const { value: order } = useContext(OrderStateContext);

    if ((!order || !order.notes)&&(!orderData||!orderData.notes)) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.titleText}>{translate("Order Notes")}</Typography>
            <Typography {...styles.notesText}>{order?.notes||orderData?.notes}</Typography>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(OrderDetailsNotes),
    definition: {
        allowedContexts: ["OrderDetailsPage", "VmiOrderDetailsPage",OrderStatusPageContext],
        group: "Order Details",
    },
};

export default widgetModule;
